import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { ApiService } from '../api.service';
import { UserService } from '../user.service';
import { UserEvents, UserMonthEvents, UserMonthlyEvents } from './models/user-events.model';
import { DatePipe } from '@angular/common';
import { getTimezoneOffset } from 'src/app/_core/utils/time-zone-offset';

@Injectable({
  providedIn: 'root',
})
export class UserEventsService {
  userEvents$: BehaviorSubject<UserEvents | null> = new BehaviorSubject<UserEvents | null>(null);
  apiUrl: string;

  constructor(
    private http: HttpClient,
    private apiService: ApiService,
    private userService: UserService,
    private datePipe: DatePipe
  ) {
    this.apiUrl = `${this.apiService.API_URL}/patrons/${this.userService.getUserId()}/events?timezoneOffset=${getTimezoneOffset()}`;
  }

  userEventEndpoint(): Observable<UserEvents> {
    return this.http.get<UserEvents>(this.apiUrl).pipe(
      map((response: UserEvents) => {
        this.userEvents$.next(response);
        return response;
      }),
      catchError((error: HttpErrorResponse) => {
        throw error.message;
      })
    );
  }

  userMonthlyEvents(): Observable<UserMonthlyEvents> {
    return this.http.get<UserEvents>(this.apiUrl).pipe(
      map((response: UserEvents) => {
        return this.toMonthlyEvents(response);
      }),
      catchError((error: HttpErrorResponse) => {
        throw error.message;
      })
    );
  }

  private toMonthlyEvents(userEvents: UserEvents): UserMonthlyEvents {
    const monthlyEvents = new Map<string, UserMonthEvents>();
    for (const event of userEvents.dayEvents) {
      const month = this.datePipe.transform(event.date, 'MMMM');
      if (!monthlyEvents.has(month)) {
        monthlyEvents.set(month, { month: month, dayEvents: [] });
      }

      monthlyEvents.get(month).dayEvents.push(event);
    }

    return {
      showEvents: userEvents.showEvents,
      monthEvents: Array.from(monthlyEvents.values()),
    };
  }
}
